import { render } from "./FourElement.vue?vue&type=template&id=3fcd13e0&scoped=true"
import script from "./FourElement.vue?vue&type=script&lang=js"
export * from "./FourElement.vue?vue&type=script&lang=js"

import "./FourElement.vue?vue&type=style&index=0&id=3fcd13e0&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcd13e0"]])

export default __exports__